import { withChartLayout } from 'components/common';
import MiscellaneousNursingNotes from 'components/features/chart/special-charts/miscellaneous-nursing-notes/MiscellaneousNursingNotes';

const MiscellaneousNursingNotesPage = withChartLayout('Miscellaneous Nursing Notes')(MiscellaneousNursingNotes);
export default MiscellaneousNursingNotesPage;
